import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';

@Injectable()
export abstract class OCPPService {
    protected BASE_PATH = environment.API_BASE_PATH;
    abstract getProfileBasePath(): string;
}


